import { render, staticRenderFns } from "./NominationInformation.vue?vue&type=template&id=36365441&scoped=true&"
import script from "./NominationInformation.vue?vue&type=script&lang=js&"
export * from "./NominationInformation.vue?vue&type=script&lang=js&"
import style0 from "./NominationInformation.vue?vue&type=style&index=0&id=36365441&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36365441",
  null
  
)

export default component.exports